<template>
  <div class="file-progress" id="FileProgress">
    <div :style="{width: '70vw', maxWidth: '600px'}">
        <div :style="{position: 'relative'}">
        <div :style="{padding: '20px'}">
        <span class="textBar">{{ currentfile }} de {{ filesTotal }} enviadas</span>
        </div>
          <div :style="{
            width : this.percentage + '%',
            backgroundColor: 'white',
            height: '12px',
            borderRadius: '12px',
            position:'absolute' }"></div>
          <div class="progressBar" >
            </div>
        </div>
     </div>
	</div>
</template>

<script>
export default {
	name: "FileProgress",
	data() {
		return {
		};
  	},
  	props: {
	percentage: {
      type: Number,
      required: true
	},
	filesTotal: {
      type: Number,
      required: true
	},
	currentfile: {
      type: Number,
      required: true
	},
	}
}
</script>

<style scoped>
	.progressBar{
		height: 12px;
		border-radius: 12px;
		width: 100%;
		color: white;
		background-color: white;
		opacity: 0.2;
		box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
		font-size: 18px;
		display: flex;
    	align-items: center;
	}
	.textBar{
		font-weight: bold;
		font-size: 18px;
		padding: 30px;
		color: white
	}
  .file-progress {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 99999;
		background-color: var(--field__background);
		overflow-y: auto;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
		padding: 12%;
	}
</style>



// WEBPACK FOOTER //
// src/components/organisms/FileProgress.vue